





import { Component, Vue } from 'vue-property-decorator';
import ContactForm from './components/ContactForm.vue';

@Component({
    components: {
        ContactForm,
    },
})
export default class App extends Vue { }
